import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { LogInResponse } from "src/app/models/user/log-in.response";
import { PaymentDevice } from "src/app/models/user/paymentDevice";
import { UserProfile } from "src/app/models/user/userProfile";
@Injectable({ providedIn: "root" })
export class USERStoreService {
	private userProfileData = new BehaviorSubject<UserProfile>({});
	public outComeText: string;
	public userAcctionFrom: string;
	public accountCreateFormData: any;
	public accountfromLogin: boolean;
	public paymentDevice: PaymentDevice;
	public saveToProfile: boolean;
	public saveToProfileShortName: string;
	public loginPopupRequest: boolean;
	public userProfile$(): Observable<UserProfile> {
		return this.userProfileData.asObservable();
	}

	public setUserProfile(data: UserProfile) {
		this.userProfileData.next(data);
	}
	public getUserProfile() {
		return this.userProfileData.value;
	}
	public setUserProfileFromResponse(response, request) {
		if (response && response.userProfile) {
			this.userProfileData.next(response.userProfile);
		} else {
			this.userProfileData.next(request);
		}
	}
}
